(function () {
  const SECTION_SELECTOR = '.section-job-offers';
  const section = document.querySelector(SECTION_SELECTOR);
  if (!section) return;

  const BAMBOO_URL = 'https://kencko.bamboohr.com/jobs/embed2.php?version=1.0.0';

  const searchInput = section.querySelector('.job-search-input');
  const tagsContainer = section.querySelector('.job-role .job-offers-dropdown__tags');
  const rolePlaceholderEl = section.querySelector('[data-role-placeholder]');
  const clearRolesBtn = section.querySelector('[data-clear-roles]');
  const rolePanel = section.querySelector('[data-role-panel]');
  const roleList = section.querySelector('[data-role-list]');
  const locationTagsContainer = section.querySelector('[data-location-tags]');
  const locationPlaceholderEl = section.querySelector('[data-location-placeholder]');
  const clearLocationBtn = section.querySelector('[data-clear-location]');
  const locationPanel = section.querySelector('[data-location-panel]');
  const locationList = section.querySelector('[data-location-list]');
  const roleDropdown = section.querySelector('.job-offers-dropdown--role');
  const locationDropdown = section.querySelector('.job-offers-dropdown--location');
  const resultsContainer = section.querySelector('[data-job-results]');
  const countEl = section.querySelector('[data-jobs-count]');
  const noResultsEl = section.querySelector('[data-no-results]');
  const noJobsEl = section.querySelector('[data-no-jobs]');

  let jobs = [];
  let selectedRoles = [];
  let selectedLocations = [];
  let searchQuery = '';

  function normalize(s) {
    return (s || '').toString().toLowerCase().trim();
  }

  function escapeHtml(s) {
    const div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
  }

  async function fetchBambooJobs() {
    try {
      const response = await fetch(BAMBOO_URL);
      if (!response.ok) return [];

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const list = [];

      doc.querySelectorAll('.BambooHR-ATS-Department-Item').forEach((outerElement) => {
        const teamHTMLElement = outerElement.querySelector('.BambooHR-ATS-Department-Header');
        const team = teamHTMLElement ? teamHTMLElement.textContent.trim() : '';

        outerElement.querySelectorAll('.BambooHR-ATS-Jobs-Item').forEach((innerElement) => {
          const linkEl = innerElement.querySelector('a');
          const job = {
            title: linkEl ? linkEl.textContent.trim() : '',
            link: linkEl ? linkEl.href : '',
            location: innerElement.querySelector('.BambooHR-ATS-Location')?.textContent?.trim() || '',
            role: team,
          };

          if (job.title) list.push(job);
        });
      });

      return list;
    } catch (e) {
      console.error('Failed to fetch Bamboo jobs:', e);
      return [];
    }
  }

  function renderRoleOptions() {
    if (!roleList) return;
    const roles = [...new Set(jobs.map((job) => job.role).filter(Boolean))];
    roleList.innerHTML = roles
      .map(
        (role) =>
          '<li class="job-offers-dropdown__option style-p3" data-value="' +
          escapeHtml(role) +
          '"><span>' +
          escapeHtml(role) +
          '</span></li>'
      )
      .join('');
  }

  function renderLocationOptions() {
    if (!locationList) return;
    const locations = [...new Set(jobs.map((job) => job.location).filter(Boolean))];
    locationList.innerHTML = locations
      .map(
        (loc) =>
          '<li class="job-offers-dropdown__option style-p3" data-value="' +
          escapeHtml(loc) +
          '"><span>' +
          escapeHtml(loc) +
          '</span></li>'
      )
      .join('');
  }

  function renderJobCards() {
    if (!resultsContainer) return;
    resultsContainer.querySelectorAll('[data-job-card]').forEach((card) => card.remove());

    const cardsHtml = jobs
      .map((job) => {
        const roleHtml = job.role
          ? '<div class="job-offers-role style-p5 col-span-6 md:col-span-3 flex justify-center items-center">' +
            escapeHtml(job.role) +
            '</div>'
          : '';
        const locationHtml = job.location
          ? '<div class="job-offers-location style-p5 col-span-6 md:col-span-3 flex justify-center items-center">' +
            escapeHtml(job.location) +
            '</div>'
          : '';

        return (
          '<div class="job-offers-card p-md rounded-md bg-shade grid grid-cols-6 md:grid-cols-12 m-0" data-job-card' +
          ' data-title="' + escapeHtml(job.title) + '"' +
          ' data-role="' + escapeHtml(job.role) + '"' +
          ' data-location="' + escapeHtml(job.location) + '"' +
          '>' +
          '<a href="' + escapeHtml(job.link) + '" target="_blank" class="job-offers-card__link no-underline text-black col-span-6 md:col-span-6">' +
          '<span class="job-offers-card__title style-p3 font-600">' + escapeHtml(job.title) + '</span>' +
          '</a>' +
          roleHtml +
          locationHtml +
          '</div>'
        );
      })
      .join('');

    if (noResultsEl) {
      noResultsEl.insertAdjacentHTML('beforebegin', cardsHtml);
    } else {
      resultsContainer.insertAdjacentHTML('beforeend', cardsHtml);
    }
  }

  function matchesSearch(job) {
    if (!searchQuery) return true;
    const q = normalize(searchQuery);
    return (
      normalize(job.dataset.title).includes(q) ||
      normalize(job.dataset.role).includes(q) ||
      normalize(job.dataset.location).includes(q)
    );
  }

  function matchesRoles(job) {
    if (selectedRoles.length === 0) return true;
    const jobRole = normalize(job.dataset.role);
    return selectedRoles.some((r) => normalize(r) === jobRole);
  }

  function matchesLocation(job) {
    if (selectedLocations.length === 0) return true;
    const jobLocation = normalize(job.dataset.location);
    return selectedLocations.some((loc) => normalize(loc) === jobLocation);
  }

  function applyFilters() {
    const cards = section.querySelectorAll('[data-job-card]');
    let visible = 0;
    cards.forEach((card) => {
      const show = matchesSearch(card) && matchesRoles(card) && matchesLocation(card);
      if (show) {
        card.style.display = '';
        card.hidden = false;
        visible++;
      } else {
        card.style.display = 'none';
        card.hidden = true;
      }
    });

    const hasJobs = jobs.length > 0;
    if (noJobsEl) {
      noJobsEl.hidden = hasJobs;
    }
    if (noResultsEl) {
      noResultsEl.hidden = !hasJobs || visible > 0;
    }

    if (countEl) {
      const text = countEl.textContent;
      const match = text.match(/\d+\s+(.+)/);
      const label = match ? match[1] : 'open roles';
      countEl.textContent = visible + ' ' + label;
    }
  }

  function renderRoleTags() {
    if (!tagsContainer) return;
    tagsContainer.innerHTML = '';
    selectedRoles.forEach((role) => {
      const tag = document.createElement('span');
      tag.className = 'job-offers-dropdown__tag rounded-sm bg-shade';
      tag.innerHTML =
        '<span class=style-p5>' +
        escapeHtml(role) +
        '</span>' +
        '<button type="button" class="job-offers-dropdown__tag-remove" data-role="' +
        escapeHtml(role) +
        '" aria-label="Remove">' +
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13" width="12" height="13"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"/></svg>' +
        '</button>';
      tagsContainer.appendChild(tag);
    });
    if (rolePlaceholderEl) rolePlaceholderEl.hidden = selectedRoles.length > 0;
    if (clearRolesBtn) clearRolesBtn.hidden = selectedRoles.length === 0;
    applyFilters();
  }

  function openRolePanel() {
    if (rolePanel) rolePanel.hidden = false;
    if (locationPanel) locationPanel.hidden = true;
  }

  function closeRolePanel() {
    if (rolePanel) rolePanel.hidden = true;
  }

  function openLocationPanel() {
    if (locationPanel) locationPanel.hidden = false;
    if (rolePanel) rolePanel.hidden = true;
  }

  function closeLocationPanel() {
    if (locationPanel) locationPanel.hidden = true;
  }

  function renderLocationTags() {
    if (!locationTagsContainer) return;
    locationTagsContainer.innerHTML = '';
    selectedLocations.forEach((loc) => {
      const tag = document.createElement('span');
      tag.className = 'job-offers-dropdown__tag rounded-sm bg-shade';
      tag.innerHTML =
        '<span class=style-p5>' +
        escapeHtml(loc) +
        '</span>' +
        '<button type="button" class="job-offers-dropdown__tag-remove" data-location="' +
        escapeHtml(loc) +
        '" aria-label="Remove">' +
        '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close-small" viewBox="0 0 12 13" width="12" height="13"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M8.486 9.33 2.828 3.67M2.885 9.385l5.544-5.77"/></svg>' +
        '</button>';
      locationTagsContainer.appendChild(tag);
    });
    if (locationPlaceholderEl) locationPlaceholderEl.hidden = selectedLocations.length > 0;
    if (clearLocationBtn) clearLocationBtn.hidden = selectedLocations.length === 0;
    applyFilters();
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      searchQuery = this.value;
      applyFilters();
    });
  }

  if (roleList) {
    roleList.addEventListener('click', function (e) {
      const opt = e.target.closest('[data-value]');
      if (!opt) return;
      const value = opt.dataset.value;
      if (!value) return;
      if (!selectedRoles.includes(value)) {
        selectedRoles.push(value);
        renderRoleTags();
      }
      closeRolePanel();
    });
  }

  tagsContainer?.addEventListener('click', function (e) {
    const btn = e.target.closest('.job-offers-dropdown__tag-remove');
    if (!btn) return;
    const role = btn.dataset.role;
    if (role) {
      selectedRoles = selectedRoles.filter((r) => r !== role);
      renderRoleTags();
    }
  });

  if (clearRolesBtn) {
    clearRolesBtn.addEventListener('click', function () {
      selectedRoles = [];
      renderRoleTags();
      closeRolePanel();
    });
  }

  if (roleDropdown) {
    roleDropdown.addEventListener('click', function (e) {
      if (roleDropdown.hasAttribute('disabled')) return;
      // Don't toggle if clicking on remove button or clear button
      if (e.target.closest('.job-offers-dropdown__tag-remove') || e.target.closest('[data-clear-roles]'))
        return;
      e.stopPropagation();
      if (rolePanel?.hidden) openRolePanel();
      else closeRolePanel();
    });
  }

  if (locationList) {
    locationList.addEventListener('click', function (e) {
      const opt = e.target.closest('[data-value]');
      if (!opt) return;
      const value = (opt.dataset.value ?? '').trim();
      if (!value) return;
      if (!selectedLocations.includes(value)) {
        selectedLocations.push(value);
        renderLocationTags();
      }
      closeLocationPanel();
    });
  }

  locationTagsContainer?.addEventListener('click', function (e) {
    const btn = e.target.closest('.job-offers-dropdown__tag-remove');
    if (!btn) return;
    const loc = btn.dataset.location;
    if (loc) {
      selectedLocations = selectedLocations.filter((l) => l !== loc);
      renderLocationTags();
    }
    closeLocationPanel();
  });

  if (clearLocationBtn) {
    clearLocationBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      selectedLocations = [];
      renderLocationTags();
      closeLocationPanel();
    });
  }

  if (locationDropdown) {
    locationDropdown.addEventListener('click', function (e) {
      if (locationDropdown.hasAttribute('disabled')) return;
      // Don't toggle if clicking on remove button or clear button
      if (e.target.closest('.job-offers-dropdown__tag-remove') || e.target.closest('[data-clear-location]'))
        return;
      e.stopPropagation();
      if (locationPanel?.hidden) openLocationPanel();
      else closeLocationPanel();
    });
  }

  document.addEventListener('click', function (e) {
    if (!section.contains(e.target)) {
      closeRolePanel();
      closeLocationPanel();
    }
  });

  function updateDropdownsAvailability() {
    const hasJobs = jobs.length > 0;
    [roleDropdown, locationDropdown].forEach((dropdown) => {
      if (!dropdown) return;
      dropdown.toggleAttribute('disabled', !hasJobs);
      dropdown.classList.toggle('job-offers-dropdown--disabled', !hasJobs);
    });
  }

  // Initialize
  fetchBambooJobs().then((fetchedJobs) => {
    jobs = fetchedJobs;
    updateDropdownsAvailability();
    renderRoleOptions();
    renderLocationOptions();
    renderJobCards();
    renderLocationTags();
    renderRoleTags();
    applyFilters();
  });
})();
